import { render, staticRenderFns } from "./LoteAnimal.vue?vue&type=template&id=71c64020&scoped=true"
import script from "./LoteAnimal.vue?vue&type=script&lang=js"
export * from "./LoteAnimal.vue?vue&type=script&lang=js"
import style0 from "./LoteAnimal.vue?vue&type=style&index=0&id=71c64020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c64020",
  null
  
)

export default component.exports